import {ProductPrinterObject} from "./productPrinter";
import ChartOptions from "../config/ChartOptions";
import DatasetModel from "./DatasetModel";
import defaultOptions from "../config/ConfiguratorOptions";
import {ScreenHelper} from "./ScreenHelper";

class ProductPrinterWebsite extends ProductPrinterObject {

  resolveChartOptions(nid, collectionName) {

    let options = ChartOptions(
      this.resolveDatasetForOneProduct(nid, collectionName),
      JSON.parse(this.$refs.chart.dataset.graphCalculationStyle),
      collectionName
    )

    console.log(ScreenHelper.getResponsiveLabelSizeForProductPrinter())

    options.options.scales.xAxes[0].scaleLabel.fontSize = ScreenHelper.getResponsiveLabelSizeForProductPrinter()
    options.options.scales.yAxes[0].scaleLabel.fontSize = ScreenHelper.getResponsiveLabelSizeForProductPrinter()
    return options
  }

  pushDataset(nid, datasets, collectionName) {
    datasets.push(DatasetModel(nid,
      JSON.parse(this.$refs.chart.dataset.graphData)[collectionName ?? 'cooling_performances'])
    )
  }

  resolveDatasetForOneProduct(nid, collectionName) {
    const datasets = []
    this.pushDataset(nid, datasets, collectionName ?? 'cooling_performances');
    return datasets
  }

}

if (!process.env.JEST_WORKER_ID !== undefined) {
  window.ProductPrinterWebsite = ProductPrinterWebsite
}

export default ProductPrinterWebsite



